import React, { ReactNode } from 'react'

import { MarginProps } from 'styled-system'

import { Text } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

type Props = MarginProps & {
  centered?: boolean
  inverse?: boolean
  text: ReactNode
}

function ContentBlockHeading({ centered, inverse, text, ...rest }: Props) {
  const { isMobile } = useResponsiveLayout()

  return (
    <Text
      {...rest}
      as="h4"
      bold
      center={centered}
      important={!inverse}
      inverse={inverse}
      screen16={isMobile}
      screen18={!isMobile}
    >
      {text}
    </Text>
  )
}

export default ContentBlockHeading
